const BACKEND_URL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace(/\/api$/, '')
  : 'https://stonari-official-backend.onrender.com';

let intervalId = null;

const ping = async () => {
  try {
    await fetch(`${BACKEND_URL}/health`, { method: 'GET' });
    console.log('[KeepAlive] Backend pinged successfully');
  } catch (err) {
    // Silent fail — don't affect user experience
  }
};

export const startKeepAlive = () => {
  if (intervalId) return; // Already running
  ping(); // Ping immediately on start
  intervalId = setInterval(ping, 10 * 60 * 1000); // Every 10 minutes
};

export const stopKeepAlive = () => {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
};
